// extracted by mini-css-extract-plugin
export default {"content":"DocumentsContent_content__1yHM+"};